import useI18n from '@/hooks/use18n'
import NumberFlow, { NumberFlowProps } from '@number-flow/react'

export default function LocalizedNumberFlow({
  value,
  className,
  format
}: {
  value: number
  className?: string
  format?: NumberFlowProps['format']
}) {
  const { currentLanguage } = useI18n()
  return <NumberFlow className={className} lang={currentLanguage} value={value} format={format} />
}
